import { useEffect, useState } from 'react';
import {
  useParams,
  useNavigate,
  useLocation
} from "react-router-dom";
import axios from 'axios';
import API_URL from '../config';
import {
  FaArrowLeft,
  FaMapMarkerAlt,
  FaMoneyBillWave,
  FaBriefcase,
  FaCalendarAlt,
  FaClock,
  FaUserMd,
  FaBookmark,
  FaRobot,
  FaCheckCircle,
  FaTimesCircle,
  FaBuilding,
  FaStar
} from "react-icons/fa";

function JobDetails() {

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
const user = JSON.parse(
  localStorage.getItem("user")
);

  const [job, setJob] = useState(null);
  const [match, setMatch] = useState({
  score: 0,
  skillsMatched: 0,
  totalSkills: 0,
  experience: false,
  qualification: "",
  location: false
});

  
useEffect(() => {
  fetchJob();
  fetchMatchScore();
}, [id]);

  const fetchJob = async () => {

    try {

      const res = await axios.get(
        `${API_URL}/jobs/${id}`
      );

      setJob(res.data);

    } catch (err) {
      console.log(err);
    }
  };
  const fetchMatchScore = async () => {

  if (!user || user.role !== "candidate") return;

  try {

    const res = await axios.get(
      `${API_URL}/ai-match/${user.id}/${id}`
    );

    setMatch(res.data);

  } catch (err) {

    console.log(err);

  } 

};
  const applyJob = async () => {

  if (!user) {

    alert("Please login to apply.");

    navigate("/");

    return;

  }

  if (user.role !== "candidate") {

    alert("Only candidates can apply for jobs.");

    return;

  }

  try {

    const res = await axios.post(
      `${API_URL}/applications/apply`,
      {
        job_id: Number(id),
        candidate_id: user.id
      }
    );

    alert(res.data.message);

  } catch (err) {

    console.log(err);

    if (err.response?.data?.message) {

      alert(err.response.data.message);

    } else {

      alert("Unable to apply.");

    }

  }

};
const saveJob = async () => {

  if (!user) {

    alert("Please login.");

    navigate("/");

    return;

  }

  if (user.role !== "candidate") {

    alert("Only candidates can save jobs.");

    return;

  }

  try {

    const res = await axios.post(
      `${API_URL}/saved-jobs/save`,
      {
        candidate_id: user.id,
        job_id: Number(id)
      }
    );

    alert("Job Saved Successfully");

  } catch (err) {

    console.log(err);

    if (err.response?.data?.message) {

      alert(err.response.data.message);

    } else {

      alert("Already Saved");

    }

  }

};

  if (!job) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 text-center text-base font-semibold text-slate-600">
        Loading job details...
      </div>
    );
  }

  return (
    <>
      {/* MOBILE JOB DETAILS — mobile-only responsive layout */}
      <div className="md:hidden min-h-screen bg-slate-50 pb-28">
        <div className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 px-4 py-3 backdrop-blur">
          <button
            type="button"
            onClick={() => {
              if (window.history.length > 1) navigate(-1);
              else navigate("/");
            }}
            className="inline-flex items-center gap-2 rounded-xl px-2 py-2 text-sm font-semibold text-teal-700 transition active:bg-teal-50"
          >
            <FaArrowLeft /> Back to Jobs
          </button>
        </div>

        <main className="mx-auto w-full max-w-xl space-y-4 px-3 py-4">
          {/* Job summary */}
          <section className="overflow-hidden rounded-3xl border border-teal-100 bg-white shadow-sm">
            <div className="h-2 bg-gradient-to-r from-teal-600 to-emerald-500" />
            <div className="p-4">
              <div className="flex min-w-0 items-start gap-3">
                <div className="h-16 w-16 shrink-0 overflow-hidden rounded-2xl border border-teal-100 bg-teal-50 shadow-sm">
                  <img
                    src={job.company_logo ? `${API_URL.replace('/api', '')}/${job.company_logo}` : `https://ui-avatars.com/api/?name=${encodeURIComponent(job.company_name || job.institution_name || "Company")}&background=ccfbf1&color=0f766e`}
                    alt="Company Logo"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h1 className="break-words text-xl font-extrabold leading-6 capitalize text-slate-900">{job.role || "Job Opportunity"}</h1>
                  <p className="mt-1 break-words text-sm font-medium text-slate-500">{job.company_name || job.institution_name || "Healthcare Organization"}</p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-100 bg-emerald-50 px-2.5 py-1 text-[11px] font-bold text-emerald-700"><FaClock /> Full-time</span>
                    <span className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-blue-100 bg-blue-50 px-2.5 py-1 text-[11px] font-bold text-blue-700"><FaUserMd /> <span className="break-words">{job.profession || "Healthcare"}</span></span>
                  </div>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-2.5">
                <div className="min-w-0 rounded-2xl bg-slate-50 p-3">
                  <p className="flex items-center gap-2 text-xs font-medium text-slate-500"><FaMoneyBillWave className="shrink-0 text-teal-600" /> Salary</p>
                  <p className="mt-2 break-words text-sm font-extrabold text-slate-900">{job.salary != null ? `₹${job.salary}` : "Not specified"}</p>
                </div>
                <div className="min-w-0 rounded-2xl bg-slate-50 p-3">
                  <p className="flex items-center gap-2 text-xs font-medium text-slate-500"><FaMapMarkerAlt className="shrink-0 text-teal-600" /> Location</p>
                  <p className="mt-2 break-words text-sm font-extrabold text-slate-900">{job.location || "Not specified"}</p>
                </div>
                <div className="min-w-0 rounded-2xl bg-slate-50 p-3">
                  <p className="flex items-center gap-2 text-xs font-medium text-slate-500"><FaBriefcase className="shrink-0 text-teal-600" /> Experience</p>
                  <p className="mt-2 break-words text-sm font-extrabold text-slate-900">{job.experience_required != null ? `${job.experience_required} yrs` : "Not specified"}</p>
                </div>
                <div className="min-w-0 rounded-2xl bg-slate-50 p-3">
                  <p className="flex items-center gap-2 text-xs font-medium text-slate-500"><FaCalendarAlt className="shrink-0 text-teal-600" /> Posted</p>
                  <p className="mt-2 break-words text-sm font-extrabold text-slate-900">{job.created_at ? new Date(job.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "Not available"}</p>
                </div>
              </div>
            </div>
          </section>

          {/* AI match */}
          {user?.role === "candidate" && (
            <section className="rounded-3xl border border-indigo-100 bg-gradient-to-br from-blue-50 to-indigo-50 p-4 shadow-sm">
              <h2 className="flex items-center gap-2 text-base font-extrabold text-indigo-800"><FaRobot /> AI Match Score</h2>
              <div className="mt-4 flex items-center gap-4">
                <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-2xl bg-white shadow-sm">
                  <span className="text-2xl font-extrabold text-emerald-600">{match.score}%</span>
                  <span className="text-[10px] font-bold uppercase text-slate-500">Match</span>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-bold text-slate-800">{match.score >= 90 ? "Excellent Match" : match.score >= 75 ? "Good Match" : match.score >= 50 ? "Average Match" : "Low Match"}</p>
                  <p className="mt-1 text-xs leading-5 text-slate-500">Based on skills, experience, qualification, and location.</p>
                  <div className="mt-2 flex items-center gap-1 text-sm text-amber-500">{Array.from({ length: match.score >= 90 ? 5 : match.score >= 75 ? 4 : match.score >= 50 ? 3 : 2 }, (_, index) => <FaStar key={index} />)}</div>
                </div>
              </div>
              <div className="mt-4 h-2 overflow-hidden rounded-full bg-white"><div className="h-full rounded-full bg-emerald-500 transition-all duration-500" style={{ width: `${Math.max(0, Math.min(100, Number(match.score) || 0))}%` }} /></div>
              <div className="mt-4 space-y-3 rounded-2xl bg-white/80 p-3 text-sm">
                <div className="flex items-center justify-between gap-3"><span className="text-slate-600">Skills match</span><strong className="text-slate-900">{match.skillsMatched}/{match.totalSkills}</strong></div>
                <div className="flex items-center justify-between gap-3"><span className="text-slate-600">Experience</span>{match.experience ? <FaCheckCircle className="text-emerald-600" /> : <FaTimesCircle className="text-rose-500" />}</div>
                <div className="flex items-center justify-between gap-3"><span className="text-slate-600">Location</span>{match.location ? <FaCheckCircle className="text-emerald-600" /> : <FaTimesCircle className="text-rose-500" />}</div>
                <div className="flex items-center justify-between gap-3"><span className="text-slate-600">Qualification</span><span className="text-right font-semibold text-slate-900">{typeof match.qualification === "boolean" ? (match.qualification ? <FaCheckCircle className="inline text-emerald-600" /> : <FaTimesCircle className="inline text-rose-500" />) : match.qualification}</span></div>
              </div>
            </section>
          )}

          {/* Skills */}
          <section className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="mb-4 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-50 text-teal-700"><FaCheckCircle /></span>
              <div><h2 className="text-base font-extrabold text-slate-900">Skills Required</h2><p className="mt-0.5 text-xs text-slate-500">Skills for this role</p></div>
            </div>
            <div className="flex flex-wrap gap-2">
              {job.skills_required && job.skills_required.split(",").some(skill => skill.trim()) ? job.skills_required.split(",").filter(skill => skill.trim()).map((skill, index) => <span key={index} className="max-w-full break-words rounded-full border border-teal-100 bg-teal-50 px-3 py-1.5 text-xs font-semibold text-teal-800">{skill.trim()}</span>) : <p className="text-sm text-slate-400">No skills specified.</p>}
            </div>
          </section>

          {/* Description */}
          <section className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
            <h2 className="text-base font-extrabold text-slate-900">Job Description</h2>
            <p className="mt-3 whitespace-pre-wrap break-words text-sm leading-6 text-slate-600">
  {job.description || "No job description provided."}
</p>
          </section>

          {/* Organization */}
          <section className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
            <h2 className="flex items-center gap-2 text-base font-extrabold text-slate-900"><FaBuilding className="text-teal-600" /> Organization Details</h2>
            <div className="mt-4 space-y-4">
              <div><p className="text-xs font-medium text-slate-500">Organization</p><p className="mt-1 break-words text-sm font-bold text-slate-900">{job.company_name || job.institution_name || "Not specified"}</p></div>
              <div className="flex items-start gap-3"><FaMapMarkerAlt className="mt-0.5 shrink-0 text-teal-600" /><div><p className="text-xs text-slate-500">Location</p><p className="mt-1 break-words text-sm font-semibold text-slate-900">{job.location || "Not specified"}</p></div></div>
              <div className="flex items-start gap-3"><FaMoneyBillWave className="mt-0.5 shrink-0 text-teal-600" /><div><p className="text-xs text-slate-500">Salary</p><p className="mt-1 break-words text-sm font-bold text-emerald-700">{job.salary != null ? `₹${job.salary}` : "Not specified"}</p></div></div>
            </div>
          </section>
        </main>

        {/* Sticky mobile actions */}
        <div className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white/95 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-8px_24px_rgba(15,23,42,0.08)] backdrop-blur">
          <div className="mx-auto grid max-w-xl grid-cols-[1fr_auto] gap-2.5">
            <button type="button" onClick={applyJob} className="inline-flex min-h-11 items-center justify-center rounded-xl bg-gradient-to-r from-teal-600 to-emerald-600 px-4 py-3 text-sm font-extrabold text-white shadow-sm transition active:scale-[0.98]">Apply Now</button>
            <button type="button" onClick={saveJob} aria-label="Save Job" className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-teal-200 bg-white px-4 py-3 text-sm font-bold text-teal-700 transition active:scale-[0.98]"><FaBookmark /> <span>Save</span></button>
          </div>
        </div>
      </div>


      {/* DESKTOP JOB DETAILS — original layout preserved */}
      <div className="hidden md:block">
        <div className="min-h-screen bg-slate-100 p-4 md:p-8">

  {/* Back Navigation */}
  <div className="max-w-7xl mx-auto mb-5">
    <button
      type="button"
      onClick={() => {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate("/");
        }
      }}
      className="flex items-center gap-2 text-teal-700 font-semibold hover:text-teal-900 transition"
    >
      <FaArrowLeft />
      Back to Jobs
    </button>
  </div>

  {/* 70% LEFT / 30% RIGHT */}
  <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-10 gap-6 items-stretch">

    {/* LEFT CARD: 70% */}
    <div className="lg:col-span-7 bg-white rounded-3xl border border-slate-200 shadow-sm p-6 md:p-8">

      {/* Job Header */}
      <div className="flex items-start gap-5">

        <div className="w-20 h-20 rounded-2xl overflow-hidden border border-slate-200 bg-teal-50 shrink-0">
          <img
            src={
              job.company_logo
                ? `${API_URL.replace('/api', '')}/${job.company_logo}`
                : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    job.company_name || job.institution_name || "Company"
                  )}&background=ccfbf1&color=0f766e`
            }
            alt="Company Logo"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="min-w-0 flex-1">
          <h1 className="text-2xl md:text-3xl font-bold capitalize text-slate-900 break-words">
            {job.role}
          </h1>

          <p className="text-slate-500 mt-2 flex items-center gap-2">
            {job.company_name || job.institution_name}
          </p>

          <div className="flex flex-wrap gap-2 mt-4">
            <span className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 border border-emerald-100 px-3 py-1.5 rounded-full text-sm font-semibold">
              <FaClock />
              FULL-TIME
            </span>

            <span className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1.5 rounded-full text-sm font-semibold">
              <FaUserMd />
              {job.profession || "HEALTHCARE"}
            </span>
          </div>
        </div>
      </div>

      {/* Job Overview */}
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 mt-8">

        <div className="bg-slate-50 rounded-2xl p-4">
          <div className="flex items-center gap-2 text-slate-500 text-sm">
            <FaMoneyBillWave className="text-teal-600" />
            Salary
          </div>
          <p className="font-bold text-lg text-slate-900 mt-2 break-words">
            {job.salary != null ? `₹${job.salary}` : "Not specified"}
          </p>
        </div>

        <div className="bg-slate-50 rounded-2xl p-4">
          <div className="flex items-center gap-2 text-slate-500 text-sm">
            <FaMapMarkerAlt className="text-teal-600" />
            Location
          </div>
          <p className="font-bold text-base text-slate-900 mt-2 break-words">
            {job.location || "Not specified"}
          </p>
        </div>

        <div className="bg-slate-50 rounded-2xl p-4">
          <div className="flex items-center gap-2 text-slate-500 text-sm">
            <FaBriefcase className="text-teal-600" />
            Experience
          </div>
          <p className="font-bold text-lg text-slate-900 mt-2">
            {job.experience_required != null
              ? `${job.experience_required} yrs`
              : "Not specified"}
          </p>
        </div>

        <div className="bg-slate-50 rounded-2xl p-4">
          <div className="flex items-center gap-2 text-slate-500 text-sm">
            <FaCalendarAlt className="text-teal-600" />
            Posted
          </div>
          <p className="font-bold text-sm text-slate-900 mt-2">
            {job.created_at
              ? new Date(job.created_at).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric"
                })
              : "Not available"}
          </p>
        </div>

      </div>

      {/* Skills */}
      <div className="mt-9 pt-7 border-t border-slate-100">
        <h2 className="text-2xl font-bold text-slate-900 mb-5">
          Skills Required
        </h2>

        <div className="flex flex-wrap gap-3">
          {job.skills_required &&
          job.skills_required.split(",").some(skill => skill.trim()) ? (
            job.skills_required
              .split(",")
              .filter(skill => skill.trim())
              .map((skill, index) => (
                <span
                  key={index}
                  className="bg-teal-50 text-teal-800 border border-teal-100 px-4 py-2 rounded-full text-sm font-medium"
                >
                  {skill.trim()}
                </span>
              ))
          ) : (
            <p className="text-sm text-slate-400">
              No skills specified.
            </p>
          )}
        </div>
      </div>

      {/* Job Description */}
      <div className="mt-9 pt-7 border-t border-slate-100">
        <h2 className="text-2xl font-bold text-slate-900 mb-5">
          Job Description
        </h2>

      <p className="whitespace-pre-wrap break-words text-slate-600 leading-8 text-base md:text-lg">
  {job.description || "No job description provided."}
</p>
      </div>

    </div>

    {/* RIGHT CARD: 30% */}
    <div className="lg:col-span-3 bg-white rounded-3xl border border-slate-200 shadow-sm p-5 md:p-6 h-full">

      {/* Apply and Save */}
      <button
        type="button"
        onClick={applyJob}
        className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-teal-600 to-emerald-700 text-white py-4 rounded-xl font-bold text-lg hover:from-teal-700 hover:to-emerald-800 transition"
      >
        Apply Now
      </button>

      <button
        type="button"
        onClick={saveJob}
        className="w-full mt-3 flex items-center justify-center gap-2 bg-white border border-slate-300 hover:bg-slate-50 text-slate-900 py-4 rounded-xl font-semibold transition"
      >
        <FaBookmark className="text-600" />
        Save Job
      </button>

      {/* AI Match Score */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-5 mt-6 border border-indigo-100">

        <h2 className="flex items-center gap-2 text-lg font-bold text-indigo-700">
          <FaRobot />
          AI Match Score
        </h2>

        <div className="text-center mt-5">
          <div className="text-5xl font-bold text-emerald-600">
            {match.score}%
          </div>

          <div className="flex items-center justify-center flex-wrap gap-2 text-slate-600 mt-3 text-sm">
            <span>
              {match.score >= 90
                ? "Excellent Match"
                : match.score >= 75
                ? "Good Match"
                : match.score >= 50
                ? "Average Match"
                : "Low Match"}
            </span>

            <span className="flex items-center gap-1 text-amber-500" aria-label="Match rating">
              {Array.from(
                { length: match.score >= 90 ? 5 : match.score >= 75 ? 4 : match.score >= 50 ? 3 : 2 },
                (_, index) => (
                  <FaStar key={index} />
                )
              )}
            </span>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-slate-200 rounded-full h-2.5 mt-5 overflow-hidden">
          <div
            className="bg-emerald-500 h-2.5 rounded-full transition-all duration-500"
            style={{
              width: `${Math.max(0, Math.min(100, Number(match.score) || 0))}%`
            }}
          />
        </div>

        {/* Match Breakdown */}
        <div className="mt-6 space-y-4 text-sm">

          <div className="flex justify-between items-center gap-2">
            <span className="text-slate-700">Skills Match</span>
            <span className="font-semibold text-slate-900">
              {match.skillsMatched}/{match.totalSkills}
            </span>
          </div>

          <div className="flex justify-between items-center gap-2">
            <span className="text-slate-700">Experience</span>
            {match.experience ? (
              <FaCheckCircle className="text-emerald-600" />
            ) : (
              <FaTimesCircle className="text-rose-500" />
            )}
          </div>

          <div className="flex justify-between items-center gap-2">
            <span className="text-slate-700">Location</span>
            {match.location ? (
              <FaCheckCircle className="text-emerald-600" />
            ) : (
              <FaTimesCircle className="text-rose-500" />
            )}
          </div>

          <div className="flex justify-between items-center gap-2">
            <span className="text-slate-700">Qualification</span>
            <span className="font-semibold text-slate-900 text-right">
              {typeof match.qualification === "boolean" ? (
                match.qualification ? (
                  <FaCheckCircle className="text-emerald-600 inline" />
                ) : (
                  <FaTimesCircle className="text-rose-500 inline" />
                )
              ) : (
                match.qualification
              )}
            </span>
          </div>

        </div>
      </div>

      {/* Organization Details */}
      <div className="mt-6 pt-6 border-t border-slate-200 space-y-5">

        <h2 className="flex items-center gap-2 text-lg font-bold text-slate-900">
          <FaBuilding className="text-teal-600" />
          Organization Details
        </h2>

        <div>
          <p className="text-sm text-slate-500">Organization</p>
          <p className="font-semibold text-slate-900 mt-1 break-words">
            {job.company_name || job.institution_name || "Not specified"}
          </p>
        </div>

        <div>
          <p className="flex items-center gap-2 text-sm text-slate-500">
            <FaMapMarkerAlt className="text-teal-600" />
            Location
          </p>
          <p className="font-semibold text-slate-900 mt-1">
            {job.location || "Not specified"}
          </p>
        </div>

        <div>
          <p className="flex items-center gap-2 text-sm text-slate-500">
            <FaMoneyBillWave className="text-teal-600" />
            Salary
          </p>
          <p className="font-bold text-emerald-600 mt-1">
            {job.salary != null ? `₹${job.salary}` : "Not specified"}
          </p>
        </div>

      </div>

    </div>

  </div>
</div>
      </div>
    </>
  );
}

export default JobDetails;
